'use client';

import routes from '@/app/routes';
import Breadcrumbs from '@/components/Breadcrumb';
import HeaderNavigator from '@/components/Navigator';
import AddProductionReportingListWrapper from './wrapper';
import { useLocation, useSearchParams } from 'react-router-dom';

type LocationState = {
  facilityCode?: string;
};

const AddProductionReportingListPage: React.FC = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const facilityCode = (location.state as LocationState | null)?.facilityCode;

  return (
    <>
      <HeaderNavigator title="Production periods" />
      <Breadcrumbs
        items={[
          {
            label: 'Home',
            path: `${routes.PRODUCTION_REPORTING}?${searchParams.toString()}`,
          },
          { label: 'Production periods' },
        ]}
        maxVisible={4}
        className="w-full fixed top-[112px]"
      />
      <AddProductionReportingListWrapper />
    </>
  );
};

export default AddProductionReportingListPage;
